import React from 'react'
import { SIZES } from 'src/styles/theme'
import styled from 'styled-components'

const TermsWrapper = styled.div`
  padding: 12px;
  color: #022136;
  font-size: 90%;
  max-height: 350px;
  overflow-y: scroll;
  h6 {
    color: #F85D49;
    font-weight: 600;
  }
  h6, p {
    width: 90%;
    margin: 10px auto;
  }
  p {
    display: flex;
    span {
      margin-left: 8px;
    }
  }
  ${SIZES.mobile} {
    min-height: 350px;
    max-height: inherit;
    p {
      font-size: 80%;
      span {
        margin-left: 6px;
      }
    }
  }
`

function TermsTab() {
  return (
    <TermsWrapper>
      <h6>Terms and Conditions</h6>
      <p>1.<span>Open to all registered attendees.</span></p>
      <p>2.<span>Virtual hunt is not open to exhibitors.</span></p>
      <p>3.<span>There are 10 vouchers to be won per day. Winners will be notified via email by 12pm the following day.</span></p>
      <p>4.<span>If you were not successful, you may try again the following next day.</span></p>
      <p>5.<span>Each eligible person can only win once.</span></p>
      <p>6.<span>Winners are decided by the system and the decision is final.</span></p>
      <p>7.<span>This game is open from the start of Opening Ceremony on 9th August 2022 and ends at the Closing Ceremony on 11th August 2022.</span></p>
    </TermsWrapper>
  )
}

export { TermsTab }